import { render, staticRenderFns } from "./LessonVerdictsWidget.vue?vue&type=template&id=2bc03eb4&scoped=true"
import script from "./LessonVerdictsWidget.vue?vue&type=script&lang=js"
export * from "./LessonVerdictsWidget.vue?vue&type=script&lang=js"
import style0 from "./LessonVerdictsWidget.vue?vue&type=style&index=0&id=2bc03eb4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc03eb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc03eb4')) {
      api.createRecord('2bc03eb4', component.options)
    } else {
      api.reload('2bc03eb4', component.options)
    }
    module.hot.accept("./LessonVerdictsWidget.vue?vue&type=template&id=2bc03eb4&scoped=true", function () {
      api.rerender('2bc03eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/LessonVerdictsWidget.vue"
export default component.exports